import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CertificateModel } from '@models/configuration/certificate.model';
import { Store } from '@ngrx/store';
import * as fromAppRoot from '@reducers/index';
import { TableStorageActionModel } from '@models/common/table-storage-action.model';
import { Partitions } from '@root/core/enums/partition.enum';
import { FacadeInterface } from '@interfaces/facade-interface';
import { CertificateActions } from '@actions/configuration';

@Injectable({
  providedIn: 'root'
})
export class CertificateFacadeService implements FacadeInterface<CertificateModel> {

  getAll$(): Observable<CertificateModel[]> {
    return this.store.select(fromAppRoot.getCertificates)
  }

  getCertificateStatus$(): Observable<CertificateModel[]> {
    return this.store
      .select(fromAppRoot.getCertificateStatus)
  }

  getCertificatesState$(): Observable<CertificateModel[]> {
    return this.store
      .select(fromAppRoot.getCertificatesByState)
  }

  getCertificatesFile$(): Observable<CertificateModel[]> {
    return this.store
      .select(fromAppRoot.getCertificatesFile)
  }

  getCurrentItem$(): Observable<CertificateModel> {
    return this.store
      .select(fromAppRoot.getCurrentCertificate);
  }

  search(): void {
    const props: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.CERTIFICATE}/GetAll`,
    }
    this.store.dispatch(CertificateActions.searchCertificates({ action: props }));
  }

  searchStatus(): void {
    const props: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.CERTIFICATESTATUS}/GetAll`,
    }
    this.store.dispatch(CertificateActions.searchCertificateStatus({ action: props }));
  }

  searchCertificatesState(state): void {
    const action: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.CERTIFICATE}/GetAll?status=${state}`
    }
    this.store.dispatch(CertificateActions.searchCertificatesState({ action }));
  }

  searchFile(idU:string,status:string): void {
    const props: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.CERTIFICATE}/GetStatusId?id=`+idU+'&status='+status,
    }
    this.store.dispatch(CertificateActions.searchCertificatesFile({ action: props }));
  }

  create(payload: CertificateModel): void {
    const props: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.FILESIGNATURE}?uuid=${payload.id}&newStatus=${payload.status} `,
      payload
    }
    this.store.dispatch(CertificateActions.createCertificate({ action: props }));
  }

  update(payload: CertificateModel): void {
    const action: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.CERTIFICATE}`,
      payload
    }
    this.store.dispatch(CertificateActions.updateCertificate({ action }));
  }

  select(Certificate: CertificateModel): void {
    this.store.dispatch(CertificateActions.selectCertificate({ Certificate }));
  }

  delete(payload: CertificateModel): void {
    const props: TableStorageActionModel<CertificateModel> = {
      queryParams: `${Partitions.CERTIFICATE}`,
      payload
    }
    this.store.dispatch(CertificateActions.deleteCertificate({ action: props }));
  }

  reset(): void {
  }

  resetSelected(): void {
  }

  constructor(
    private store: Store<fromAppRoot.State>,
  ) { }

}
